import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageGlowContainer from '../components/PageLayout';
import ProfessionalPage from '../components/ProfessionalPage';
import ContactLinks from '../components/ContactLinks';
import { contactContent } from '../content/contactContent';

const Contact = ({ theme }) => {
  const navigate = useNavigate();

  if (theme === 'professional') {
    return (
      <ProfessionalPage title={contactContent.title}>
        <p>{contactContent.intro}</p>
        <ContactLinks />
      </ProfessionalPage>
    );
  }

  return (
    <>
      <div className="ddr-grid"></div>
      <PageGlowContainer title={contactContent.title} glowColor={contactContent.glowColor} onEsc={() => navigate('/') }>
        <p className="contact-intro">{contactContent.intro}</p>
        <ContactLinks />
      </PageGlowContainer>
    </>
  );
};

export default Contact; 